import React from "react";
import "./styles.css";

/**
 * Banda angosta navy con cifras de credibilidad.
 * Se ubica entre el SliderHome y el LoanSimulatorSection para dar
 * social proof inmediato antes de pedir datos al usuario.
 */
export const StatsBanner = () => {
  const stats = [
    { value: "+40.000", label: "Clientes felices" },
    { value: "+20.000", label: "Motos financiadas" },
    { value: "24h", label: "Aprobación promedio" },
  ];

  return (
    <section className="stats-banner" aria-label="Cifras de Nexus">
      <ul className="stats-banner__list">
        {stats.map((stat) => (
          <li key={stat.label} className="stats-banner__item">
            <span className="stats-banner__value">{stat.value}</span>
            <span className="stats-banner__label">{stat.label}</span>
          </li>
        ))}
      </ul>
    </section>
  );
};
